import { ComboboxOptions } from '@headlessui/react';

import Props from '@/components/@base/input/combobox/options/type';

const Options = ({ children, ...props }: Props) => {
  return <ComboboxOptions {...props}>{children}</ComboboxOptions>;
};

export default Options;
